/**
 * O fundamento obrigatório de toda revisão do dado pelo painel (E203.F4, ADR-0146 §9): fica no
 * histórico do caso com o valor anterior, o autor e o instante.
 */
import { Field, Textarea } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import { FUNDAMENTO_MINIMO } from '@/lib/revisaoDoDado';

const t = ptBR.painelDoDado.fundamento;

export function fundamentoValido(fundamento: string): boolean {
  return fundamento.trim().length >= FUNDAMENTO_MINIMO;
}

/** A frase do que falta no fundamento, ou `null` quando ele basta (E207.F7.C01). */
export function faltaNoFundamento(fundamento: string): string | null {
  if (fundamentoValido(fundamento)) return null;
  return ptBR.painelDoDado.falta.fundamento.replace('{n}', String(FUNDAMENTO_MINIMO));
}

export function Fundamento({
  id,
  valor,
  onChange,
}: {
  id: string;
  valor: string;
  onChange: (valor: string) => void;
}): JSX.Element {
  return (
    <Field label={t.rotulo} description={t.dica} htmlFor={id} required>
      <Textarea id={id} value={valor} onChange={(e) => onChange(e.target.value)} data-testid={id} />
    </Field>
  );
}
